export const getButtonStyles = (isActive, type = "top") => ({
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: 400,
    color: isActive
        ? type === "top"
            ? "var(--primary)" // green for top buttons
            : "var(--btn-7)"   // orange for bottom buttons
        : "black",
    borderColor: isActive
        ? type === "top"
            ? "var(--primary)"
            : "var(--btn-7)"
        : "var(--border)",
    borderWidth: isActive ? "2px" : "1px",
    display: "flex",
    alignItems: "center",
    padding: "0px 14px",
    "&:hover": {
        borderColor: isActive
            ? type === "top"
                ? "var(--primary)"
                : "var(--btn-7)"
            : "var(--border)",
        backgroundColor: "var(--background)",
    },
});